import { createCrud } from '@lumahealthhq/ui-model';
var basePath = 'broadcastFlows/reviewers';
var crud = createCrud(basePath);

/* Default queries */
export var useBroadcastFlowReviewerCount = crud.makeCount();
export var useBroadcastFlowReviewerById = crud.makeFindById();
export var useBroadcastFlowReviewerByIds = crud.makeFindByIds();
export var useBroadcastFlowReviewerMany = crud.makeFindMany();
export var useBroadcastFlowReviewerOne = crud.makeFindOne();
export var useBroadcastFlowReviewerPagination = crud.makePagination();

/* Default mutations */
export var useBroadcastFlowReviewerCreateOne = crud.makeCreateOne();
export var useBroadcastFlowReviewerUpdateOne = crud.makeUpdateOne();
export var useBroadcastFlowReviewerRemoveById = crud.makeRemoveById();

/* Custom queries */

/* Custom mutations */